// @flow
const resultsViewStyles = {
  container: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
    width: '100%',
    maxWidth: 700,
    margin: '0 auto'
  }),

  content: (theme: Object) => ({
    width: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`
  }),

  header: (theme: Object) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2)
  }),

  successIcon: (theme: Object) => ({
    fontSize: 40,
    color: theme.palette.success.main
  }),

  errorIcon: (theme: Object) => ({
    fontSize: 40,
    color: theme.palette.error.main
  }),

  title: (theme: Object) => ({
    fontWeight: 600,
    color: theme.palette.text.primary
  }),

  alert: (theme: Object) => ({
    marginBottom: theme.spacing(2)
  }),

  summary: (theme: Object) => ({
    textAlign: 'center',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3)
  }),

  counters: (theme: Object) => ({
    display: 'flex',
    justifyContent: 'space-around',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius
  }),

  counter: (theme: Object) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    flex: 1,
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius
  }),

  counterIcon: (theme: Object) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: theme.palette.background.paper
  }),

  counterHighlight: (theme: Object) => ({
    backgroundColor: theme.palette.success.light + '20',
    border: `1px solid ${theme.palette.success.light}`
  }),

  counterError: (theme: Object) => ({
    backgroundColor: theme.palette.error.light + '20',
    border: `1px solid ${theme.palette.error.light}`
  }),

  createdIcon: (theme: Object) => ({
    color: theme.palette.success.main,
    fontSize: 28
  }),

  skippedIcon: (theme: Object) => ({
    color: theme.palette.warning.main,
    fontSize: 28
  }),

  failedIcon: (theme: Object) => ({
    color: theme.palette.error.main,
    fontSize: 28
  }),

  counterValue: (theme: Object) => ({
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1,
    marginTop: theme.spacing(0.5)
  }),

  counterLabel: (theme: Object) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center'
  }),

  errorsSection: (theme: Object) => ({
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: theme.palette.error.light + '10',
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.error.light}`
  }),

  errorsHeader: (theme: Object) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8
    }
  }),

  errorsTitle: (theme: Object) => ({
    fontWeight: 600,
    color: theme.palette.error.main
  }),

  tableContainer: (theme: Object) => ({
    maxHeight: 300,
    marginTop: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius
  }),

  tableHeaderCell: (theme: Object) => ({
    backgroundColor: theme.palette.background.paper,
    fontWeight: 600,
    whiteSpace: 'nowrap',
    position: 'sticky',
    top: 0,
    zIndex: 1
  }),

  tableCell: (theme: Object) => ({
    fontSize: '0.875rem'
  }),

  moreErrors: (theme: Object) => ({
    display: 'block',
    textAlign: 'center',
    marginTop: theme.spacing(1),
    color: theme.palette.text.secondary
  }),

  downloadButton: (theme: Object) => ({
    marginTop: theme.spacing(2),
    width: '100%'
  }),

  actions: (theme: Object) => ({
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: theme.spacing(3)
  })
};

export default resultsViewStyles;
